enum ChatRoutes {
    Chat = "/chat",
    CustomerDetails = "/customer-details",
    FindingAgent = "/finding-agent",
    Survey = "/survey",
}

export default ChatRoutes;
